<template>
    <div class="search-input">
        <VJoyInput
            :model-value="modelValue"
            :placeholder="placeholder"
            :size="size"
            name="search-input"
            icon="search"
            clearable
            @update:model-value="debounceSearch"
        />
    </div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import debounce from 'lodash-es/debounce';
    import {useTranslation} from '#imports';
    import {useDisplayMobile} from '@malt/utils';
    import type {TJoyInputSizes} from '@maltjoy/core-vue';
    import {VJoyInput} from '@maltjoy/core-vue';

    withDefaults(
        defineProps<{
            modelValue: string;
            size?: TJoyInputSizes;
        }>(),
        {
            size: 'medium',
        },
    );

    const emit = defineEmits<{
        'debouncedUpdate:modelValue': [value: string];
    }>();

    const debounceSearch = debounce(emitOmnisearch, 400);
    const {isDisplayMobile} = useDisplayMobile();
    const {t} = useTranslation();

    const placeholder = computed(() => {
        return isDisplayMobile ? t('customer.pof.list.detail.omnisearch.mobile') : t('customer.pof.list.detail.omnisearch');
    });

    function emitOmnisearch(newValue: string): void {
        emit('debouncedUpdate:modelValue', newValue);
    }
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint' as joy;

    .search-input {
        margin-left: var(--joy-core-spacing-2);
        border-radius: var(--joy-core-radius-6);
        @include joy.screen_sm {
            .m-input {
                width: auto;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                margin-bottom: 0;
                min-width: 180px;
            }
        }
    }
</style>
